import {pxToRem} from '../../utills/pxToRem'

export const trackOrderModalCloseButtonStyle = {
    color: 'black',
    position: 'absolute',
    top: [pxToRem(11), pxToRem(11), pxToRem(11), pxToRem(20)],
    right: [pxToRem(11), pxToRem(11), pxToRem(11), pxToRem(20)],
    height: pxToRem(15),
    minWidth: pxToRem(15)
}

export const trackOrderContainerStyle = {
    padding: {base: `${pxToRem(30)} ${pxToRem(11)}`, lg: `${pxToRem(40)} ${pxToRem(25)}`},
    gap: {base: `${pxToRem(20)}`, lg: `${pxToRem(25)}`},
    h2: {
        fontSize: {base: 'lg', lg: pxToRem(22)},
        fontStyle: 'normal',
        fontWeight: 'semibold',
        lineHeight: 'normal',
        textTransform: 'uppercase',
        letterSpacing: pxToRem(3),
        mb: '0'
    },
    p: {
        textAlign: 'center',
        fontSize: {base: pxToRem(12), lg: pxToRem(13)},
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: pxToRem(1)
    },
    form: {
        mt: '0 !important'
    },
    label: {
        fontSize: {base: 'sm', lg: 'md'},
        fontStyle: 'normal',
        lineHeight: 'normal',
        mb: {base: pxToRem(5), lg: pxToRem(10)},
        letterSpacing: pxToRem(1),
        color: '#000',
        _after: {
            content: `'*'`,
            color: 'cav_red',
            fontSize: {base: 'sm', lg: 'md'},
            fontStyle: 'normal',
            lineHeight: 'normal'
        }
    },
    input: {
        borderRadius: 'initial'
    },
    button: {
        width: 'full',
        mt: {base: pxToRem(20), lg: pxToRem(42)}
    },
    '[data-status="error"]': {
        alignItems: 'start'
    }
}

export const trackOrderDescriptionStyle = {}
